<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="duihuanMa">
                <span slot="label" ><a-tooltip>{{$t('积分金币兑换记录.用户昵称')}}<template slot="title">{{$t('积分金币兑换记录.用户昵称')}}</template></a-tooltip> </span>
                <a-input v-model="queryParam.userName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('积分金币兑换记录.用户昵称')" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="duihuanMa">
                <span slot="label" ><a-tooltip>{{$t('积分金币兑换记录.用户手机号')}}<template slot="title">{{$t('积分金币兑换记录.用户手机号')}}</template></a-tooltip> </span>
                <a-input v-model="queryParam.mobile" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('积分金币兑换记录.用户手机号')" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="duihuanMa">
                <span slot="label" ><a-tooltip>{{$t('积分金币兑换记录.兑换码')}}<template slot="title">{{$t('积分金币兑换记录.兑换码')}}</template></a-tooltip> </span>
                <a-input v-model="queryParam.duihuanMa" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'兑换码'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('积分金币兑换记录.兑换开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('积分金币兑换记录.兑换结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
<!--      <div class="table-operations">-->
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['zb:duihuanjilu:add']">-->
<!--          <a-icon type="plus" />{{$t('通用.按钮.新增')}}-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['zb:duihuanjilu:edit']">-->
<!--          <a-icon type="edit" />{{$t('通用.按钮.修改')}}-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['zb:duihuanjilu:remove']">-->
<!--          <a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['zb:duihuanjilu:export']">-->
<!--          <a-icon type="download" />{{$t('通用.按钮.导出')}}-->
<!--        </a-button>-->
<!--        <table-setting-->
<!--          :style="{float: 'right'}"-->
<!--          :table-size.sync="tableSize"-->
<!--          v-model="columns"-->
<!--          :refresh-loading="loading"-->
<!--          @refresh="getList" />-->
<!--      </div>-->
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="type" slot-scope="text, record">
           <custom-dict-tag :options="customDict.DuihuanSourceEnum" :value="record.type"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['zb:duihuanjilu:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['zb:duihuanjilu:edit']">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['zb:duihuanjilu:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['zb:duihuanjilu:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDuihuanJilu,listDuihuanJilu, delDuihuanJilu } from '@/api/duihuan/duihuanJilu'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'DuihuanJilu',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        duihuanMa: undefined,
        mobile: undefined,
        userName: undefined,
        type: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns:this.getTableColumns(),
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    '$i18n.locale'() {
      // 语言变化时重新设置columns
      this.columns =  this.getTableColumns();
      this.getList();
    }
  },
  methods: {
    getTableColumns() {
      return [
        // {
        //   title: this.$t('通用.文本.编号'),
        //   dataIndex: 'id',
        //   align: 'center'
        // },
        {
          title: this.$t('积分金币兑换记录.用户昵称'),
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: this.$t('积分金币兑换记录.用户手机号'),
          dataIndex: 'mobile',
          align: 'center'
        },
        // {
        //   title: this.$t('积分金币兑换记录.兑换码id'),
        //   dataIndex: 'duihuanId',
        //   align: 'center'
        // },
        {
          title: this.$t('积分金币兑换记录.兑换码'),
          dataIndex: 'duihuanMa',
          align: 'center'
        },
        {
          title: this.$t('积分金币兑换记录.兑换数量'),
          dataIndex: 'duihuanNum',
          align: 'center'
        },
        {
          title: this.$t('积分金币兑换记录.兑换类型'),
          scopedSlots: { customRender: 'type' },
          dataIndex: 'type',
          align: 'center'
        },
        // {
        //   title: this.$t('积分金币兑换记录.用户id'),
        //   dataIndex: 'userId',
        //   align: 'center'
        // },
        {
          title: this.$t('积分金币兑换记录.兑换时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        // {
        //   title: this.$t('通用.文本.操作'),
        //   dataIndex: 'operation',
        //   width: '12%',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ]
    },

    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询积分金币兑换记录列表 */
    getList () {
      this.loading = true
     pageDuihuanJilu(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        duihuanMa: undefined,
        type: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          return delDuihuanJilu(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('zb/duihuan/jilu/export',
            that.queryParam
          , `积分金币兑换记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
